import api from './api';

export interface Patient {
  id: number;
  first_name: string;
  last_name: string;
  full_name: string;
  date_of_birth: string | null;
  email: string | null;
  phone: string | null;
  status: 'active' | 'finished';
  emergency_contact_name: string | null;
  emergency_contact_phone: string | null;
  notes: string | null;
  insurance_provider: string | null;
  insurance_id: string | null;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  last_meeting_date: string | null;
}

export interface PatientCreate {
  first_name: string;
  last_name: string;
  date_of_birth?: string | null;
  email?: string | null;
  phone?: string | null;
  emergency_contact_name?: string | null;
  emergency_contact_phone?: string | null;
  notes?: string | null;
  insurance_provider?: string | null;
  insurance_id?: string | null;
  tenant_id: number;
}

export interface PatientUpdate extends Partial<PatientCreate> {
  status?: 'active' | 'finished';
}

export const patientService = {
  async getPatients(tenantId: number, status?: 'active' | 'finished'): Promise<Patient[]> {
    const params = new URLSearchParams({ tenant_id: tenantId.toString() });
    if (status) {
      params.append('status', status);
    }
    const response = await api.get(`/patients/?${params}`);
    return response.data;
  },

  async getPatient(patientId: number): Promise<Patient> {
    const response = await api.get(`/patients/${patientId}`);
    return response.data;
  },

  async createPatient(patientData: PatientCreate): Promise<Patient> {
    const response = await api.post('/patients/', patientData);
    return response.data;
  },

  async updatePatient(patientId: number, patientData: PatientUpdate): Promise<Patient> {
    const response = await api.put(`/patients/${patientId}`, patientData);
    return response.data;
  },

  async finishPatient(patientId: number): Promise<void> {
    await api.post(`/patients/${patientId}/finish`);
  },

  async revivePatient(patientId: number): Promise<void> {
    await api.post(`/patients/${patientId}/revive`);
  },
};